module.exports = __webpack_public_path__ + "static/media/image05.c9a58685.png";